import { newThemeOptions } from 'src/theme/theme';

export const primaryColors = [
  {
    label: 'Neutral',
    description: 'N800',
    hexcode: newThemeOptions.newPalette.neutral.N800,
  },
  {
    label: 'Turquoise',
    description: 'T300',
    hexcode: newThemeOptions.newPalette.turquoise.T300,
  },
  {
    label: 'Green',
    description: 'G200',
    hexcode: newThemeOptions.newPalette.green.G200,
  },
  {
    label: 'White',
    description: 'N0',
    hexcode: newThemeOptions.newPalette.neutral.N0,
  },
];
export const secondaryColors = [
  {
    label: 'Green',
    description: 'G400',
    hexcode: newThemeOptions.newPalette.green.G400,
  },
  {
    label: 'Yellow',
    description: 'Y400',
    hexcode: newThemeOptions.newPalette.yellow.Y400,
  },
  {
    label: 'Red',
    description: 'R400',
    hexcode: newThemeOptions.newPalette.red.R400,
  },
];
export const neutralArray = [
  {
    label: 'N0',
    description: null,
    hexcode: newThemeOptions.newPalette.neutral.N0,
  },
  {
    label: 'N100',
    description: 'Background lighter',
    hexcode: newThemeOptions.newPalette.neutral.N100,
  },
  {
    label: 'N200',
    description: 'Background light',
    hexcode: newThemeOptions.newPalette.neutral.N200,
  },
  {
    label: 'N300',
    description: 'Background darker',
    hexcode: newThemeOptions.newPalette.neutral.N300,
  },
  {
    label: 'N400',
    description: 'Border normal',
    hexcode: newThemeOptions.newPalette.neutral.N400,
  },
  {
    label: 'N500',
    description: 'Separators',
    hexcode: newThemeOptions.newPalette.neutral.N500,
  },
  {
    label: 'N600',
    description: 'Text paragraph',
    hexcode: newThemeOptions.newPalette.neutral.N600,
  },
  {
    label: 'N700',
    description: 'Icons muted',
    hexcode: newThemeOptions.newPalette.neutral.N700,
  },
  {
    label: 'N800',
    description: 'Text normal',
    hexcode: newThemeOptions.newPalette.neutral.N800,
  },
  {
    label: 'N900',
    description: 'Icons normal',
    hexcode: newThemeOptions.newPalette.neutral.N900,
  },
  {
    label: 'N1000',
    description: 'Headlines',
    hexcode: newThemeOptions.newPalette.neutral.N1000,
  },
];
export const turquoiseArray = [
  {
    label: 'T100',
    description: 'Info alert and hovered rows in tables',
    hexcode: newThemeOptions.newPalette.turquoise.T100,
  },
  {
    label: 'T200',
    description: null,
    hexcode: newThemeOptions.newPalette.turquoise.T200,
  },
  {
    label: 'T300',
    description: 'Focused input and select borders',
    hexcode: newThemeOptions.newPalette.turquoise.T300,
  },
  {
    label: 'T400',
    description: 'Primary buttons, links, hover, active',
    hexcode: newThemeOptions.newPalette.turquoise.T400,
  },
  {
    label: 'T500',
    description: 'Pressed primary buttons, switches, checkboxes, radio',
    hexcode: newThemeOptions.newPalette.turquoise.T500,
  },
];
export const greenArray = [
  {
    label: 'G100',
    description: 'Success alert and toast background',
    hexcode: newThemeOptions.newPalette.green.G100,
  },
  {
    label: 'G200',
    description: 'Brand green',
    hexcode: newThemeOptions.newPalette.green.G200,
  },
  {
    label: 'G300',
    description: null,
    hexcode: newThemeOptions.newPalette.green.G300,
  },
  {
    label: 'G400',
    description: 'Success status, icons and alert border',
    hexcode: newThemeOptions.newPalette.green.G400,
  },
  {
    label: 'G500',
    description:
      'Pressed success button, error alerts, toast icon, badge/pill text',
    hexcode: newThemeOptions.newPalette.green.G500,
  },
];
export const yellowArray = [
  {
    label: 'Y100',
    description: null,
    hexcode: newThemeOptions.newPalette.yellow.Y100,
  },
  {
    label: 'Y200',
    description: null,
    hexcode: newThemeOptions.newPalette.yellow.Y200,
  },
  {
    label: 'Y300',
    description: null,
    hexcode: newThemeOptions.newPalette.yellow.Y300,
  },
  {
    label: 'Y400',
    description: null,
    hexcode: newThemeOptions.newPalette.yellow.Y400,
  },
  {
    label: 'Y500',
    description: null,
    hexcode: newThemeOptions.newPalette.yellow.Y500,
  },
];
export const redArray = [
  {
    label: 'R100',
    description: 'Error alert and toast background',
    hexcode: newThemeOptions.newPalette.red.R100,
  },
  {
    label: 'R200',
    description: null,
    hexcode: newThemeOptions.newPalette.red.R200,
  },
  {
    label: 'R300',
    description: null,
    hexcode: newThemeOptions.newPalette.red.R300,
  },
  {
    label: 'R400',
    description: 'Danger status, icons and alert border',
    hexcode: newThemeOptions.newPalette.red.R400,
  },
  {
    label: 'R500',
    description:
      'Pressed error button, error alerts, toast icon, badge/pill text',
    hexcode: newThemeOptions.newPalette.red.R500,
  },
];
export const chartArray = [
  {
    label: 'Chart Blue',
    description: 'Charts first color',
    hexcode: newThemeOptions.newPalette.chart.blue,
  },
  {
    label: 'Chart Yellow',
    description: 'Charts second color',
    hexcode: newThemeOptions.newPalette.chart.yellow,
  },
  {
    label: 'Chart Red',
    description: 'Charts third color',
    hexcode: newThemeOptions.newPalette.chart.red,
  },
  {
    label: 'Chart Green',
    description: 'Charts fourth color',
    hexcode: newThemeOptions.newPalette.chart.green,
  },
  {
    label: 'Chart Pink',
    description: 'Charts fifth color',
    hexcode: newThemeOptions.newPalette.chart.pink,
  },
  {
    label: 'Chart Teal',
    description: 'Charts sixth color',
    hexcode: newThemeOptions.newPalette.chart.teal,
  },
  {
    label: 'Chart Violet',
    description: 'Charts seventh color',
    hexcode: newThemeOptions.newPalette.chart.violet,
  },
  {
    label: 'Chart Yellow 2',
    description: 'Charts eighth color',
    hexcode: newThemeOptions.newPalette.chart.yellow2,
  },
];
